define('plugin/telegram-notifications/view/TelegramNotificationsCodeView',['require','lib/view/FormView'],function (require) {

    var FormView = require('lib/view/FormView');

    /**
     * Telegram Notifications Code View
     *
     * @class TelegramNotificationsCodeView
     */
    return FormView.extend({

        template: '#telegram_code_form_view',
        ui: {
            'ok_btn': '#sb_ok_btn',
            'countdownTimer': '.countdown-timer',
            'inputs': ':input'
        },
        triggers: {
            'click @ui.ok_btn': 'ok'
        },
        modelEvents: {
            'invalid': 'render',
            'sync': 'render'
        },

        countdown : null,

        initialize: function (){
            //this.listenTo(view, 'before:show', this._beforeViewShow);
            //this.listenTo(view, 'render', this._afterRenderView);
            this.listenTo(this, 'show', this._afterViewShow);
            this.listenTo(this.model, 'sync', this._onModelSync);
        },

        getDataToRemind: function () {
            return this._getData(this.ui.inputs);
        },

        _afterViewShow: function (view, region) {
            clearInterval(this.countdown);
            this._initCountdown(this.model.get('countdown'));
        },

        _onModelSync: function (view, region) {
            clearInterval(this.countdown);
            this._initCountdown(this.model.get('countdown'));
        },

        _initCountdown : function(intervalSec){
            var _this = this;
            this.countdown = setInterval(function() {
                intervalSec-=1;
                var now = new Date().getTime();
                var distance = intervalSec*1000;
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;
                _this.ui.countdownTimer.html(minutes + ":" + seconds + "");

                if (distance < 0) {
                    clearInterval(_this.countdown);
                    _this.ui.countdownTimer.html("EXPIRED");
                    _this.triggerMethod('code:expired');
                }
            }, 1000);
        },

        destroy: function () {
            clearInterval(this.countdown);
            //this.model.fetch();
        },

        serializeData: function () {
            return _.extend({
                'is_modal': true
            }, this._serializeData());
        }

    });

});
